import { gsap } from 'gsap';
import YTPlayer from 'yt-player'

const openPopup = () => {
    const block = document.querySelector( '.wp-block-drsblocks-about' )
    if ( !block ) return
    const button = document.querySelector( '.wp-block-drsblocks-about__play' )
    if ( !button ) return
    const inner = document.querySelector( '.wp-block-drsblocks-about__popup' ),
        over = document.querySelector( '.wp-block-drsblocks-about__popup-overlay' ),
        close = document.querySelector( '.wp-block-drsblocks-about__close' ),
        ytPlayer = document.querySelector( '.wp-block-drsblocks-about__popup-iframe' ),
        watchButtonData = block.dataset.url
    const tl = gsap.timeline( { paused: true, defaults: { duration: .5, ease: 'sine' } } )
    tl.to( inner, { autoAlpha: 1 } )
    let player = new YTPlayer( ytPlayer )
    button.addEventListener( 'click', () => {
        player = new YTPlayer( ytPlayer )
        player.load( watchButtonData, [ true ] )
        player.play()
        tl.play()
    } )
    close.addEventListener( 'click', () => {
        tl.reverse()
        player.pause()
    } )
    over.addEventListener( 'click', () => {
        tl.reverse()
        player.pause()
    } )
}

const initRotation = () => {
    const block = document.querySelector( '.wp-block-drsblocks-about' )
    if ( !block ) return
    const text = block.querySelector( '.wp-block-drsblocks-about__rotate svg:nth-child(2)' )

    gsap.to( text, {
        rotation: 360,
        duration: 30,
        ease: 'none',
        repeat: -1,
    } )
}

document.addEventListener( 'DOMContentLoaded', () => {
    initRotation()
    openPopup()
} )